// extracted by mini-css-extract-plugin
module.exports = {"desktop":"TopHeaderFloating_desktop_o7ut1","mobile":"TopHeaderFloating_mobile_ZVfRM","logo":"TopHeaderFloating_logo_26XoR"};